import { Component } from '@theme/component';

const activeClass = 'quick-nav-link--active';
const linkSelector = '.quick-nav-link';
const contentSelectorId = 'quick-nav-content';

/**
 * A custom element that manages the quick navigation links.
 * Adds 'active' class to clicked link and removes from others.
 */
export class QuickNavComponent extends Component {
  #mediaQueryLarge = matchMedia('(min-width: 1025px)');

  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  /**
   * Sets the active link in the quick navigation.
   * @param {Element} target - The target link to activate.
   */
  _setActiveLink(target) {
    const links = this.querySelectorAll(linkSelector);
    links.forEach((link) => link.classList.remove(activeClass));
    target.classList.add(activeClass);
  }

  /**
   * Handles click on quick nav link.
   * @param {Event} e - The click event.
   */
  quickNavLinkClick(e) {
    const target = /** @type {HTMLElement} */ (e.target);
    const href = target?.getAttribute('href');
    
    if (!href || !href.startsWith('#')) return;

    e.preventDefault();

    if (target) {
      const stickySidebar = document.querySelector('sticky-sidebar');
      let sidebarHeight = 0;

      if (stickySidebar instanceof HTMLElement) {
        sidebarHeight = stickySidebar.offsetHeight;
        if (this.#mediaQueryLarge.matches) {
          sidebarHeight = 0;
        }
      }
      const targetIndex = target.getAttribute('href')?.replace('#', '');
      const contentContainer = document.getElementById(contentSelectorId);
      if (contentContainer && Number(targetIndex)) {
        const summaryList = contentContainer.querySelectorAll('summary');
        const targetSummary = summaryList[targetIndex ? parseInt(targetIndex) - 1 : 0];
        if (targetSummary) {
          this.scrollToWithOffset(targetSummary, sidebarHeight);
          this._setActiveLink(target);
        }
      }
    }
  }

  /**
   * Smoothly scrolls to a specific element with an offset.
   * @param {Element} el - The target element to scroll to.
   * @param {Number} offset - The offset to apply to the scroll position.
   * @returns {void}
   */
  scrollToWithOffset(el, offset = 0) {
    if (!el) return;

    const y = el.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}

if (!customElements.get('quick-nav')) {
  customElements.define('quick-nav', QuickNavComponent);
}
